import _ from 'underscore';

import { Set } from '~commonInfra/utils/Set';
import { ITaggedItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';

export module TagsHelper {

  export interface ITagsChange {
    addTags: string[];
    removeTags: string[];
  }

  export function tagsListFromTaggedItemSet(taggedSet: Set<ITaggedItemInfo>): Map<string,number> {
    let allTags: string[] = [];
    taggedSet.each((taggedItem: ITaggedItemInfo) => {
      allTags.push(...taggedItem.tags);
    });
    return convertArrayToMap(allTags);
  }

  export function tagsListFromTaggedItemArray(taggedSet: any[]): Map<string,number> {
    let allTags: string[] = [];
    _.each(taggedSet, (taggedItem) => {
      if(taggedItem.contentType === 'databaseWithCrass' || taggedItem.contentType === 'tableWithCrass') {
        taggedItem.tags = mapObjectToStringArray(taggedItem.tags);
      }
      allTags.push(...taggedItem.tags);
    });

    return convertArrayToMap(allTags);
  }

  function mapObjectToStringArray(tags: any): any {
    let contentTags: string[] = [];
    _.each(tags, (tag)=> {
      contentTags.push(tag.name);
    });
    return contentTags;
  }

  export function parseTagString(tagString: string): string[] {
    const tagList: string[] = [];
    tagString = tagString.replace(/"[^"]*?"/g, function(quotedTag) {
      tagList.push(quotedTag);
      return '';
    });

    const splitTags = _.flatten(_.map(tagString.split(','), (commaSplitTag) => commaSplitTag.split(' ')));
    return _.union<string>(tagList, splitTags);
  }

  export function quote(tag: string): string {
    return _(tag).contains('"') ? tag : ('"' + tag + '"');
  }

  export function unquote(tag: string): string {
    return tag.replace(/^"([^"]*)"$/, '$1');
  }

  export function displayTagHtml(tag: string): string {
    return _.escape(unquote(tag)).replace(/ /g, '&nbsp;');
  }

  export function convertArrayToMap(tags: string[]): Map<string,number> {
    const tagMap = new Map<string,number>();
    if(tags){
      tags.forEach(tag => {
        const originalTagCount = tagMap.get(tag) ?? 0;
        tagMap.set(tag, originalTagCount + 1);
      });
    }
    return tagMap;
  }

  export function getTagNamesFromMap(tags: Map<string,number>): string[] {
    return Array.from(tags.keys());
  }

}
